// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0fe5ef24","186":"706e9c02","225":"3d9dab69","272":"0c60345a","372":"0909d7df","377":"4ce58711","573":"c656f1f3","738":"856163a9","841":"df5e0aba","856":"90b4ee9d","909":"707e2aa3"}[chunkId] + ".chunk.js";
};